import { withTranslation } from 'react-i18next'
import Premium from './Premium'

export default withTranslation()(Premium)
